// third-party
import { createSlice } from "@reduxjs/toolkit";

// project imports
import axios from "utils/axios";
import { dispatch } from "../index";

// initial state
interface buildingState {
  error: Error | null;
  list: Building[];
  benefit: Benefit | null;
  expend: Expend | null;
}

const initialState: buildingState = {
  error: null,
  list: [],
  benefit: null,
  expend: null
};

// ==============================|| SLICE - MENU ||============================== //

const building = createSlice({
  name: "building",
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },

    getListSuccess(state, action) {
      const myBuilds: Building[] = action.payload.my_builds || [];

      myBuilds.forEach((building, buildingIndex) => {
        myBuilds[buildingIndex].to_level = building.level + 1 > building.max_level ? building.max_level : building.level + 1;
      });

      state.list = myBuilds;
      state.benefit = action.payload.benefit;
    },

    setLevel(state, action) {
      const { buildType, level } = action.payload;
      const _list: Building[] = JSON.parse(JSON.stringify(state.list));

      _list.forEach((building, buildingIndex) => {
        if (building.build_type === buildType) {
          if (level > building.max_level) {
            _list[buildingIndex].to_level = building.max_level;
          } else {
            _list[buildingIndex].to_level = level;
          }
        }
      });

      state.list = _list;
    },

    getBuildingExpendSuccess(state, action) {
      state.expend = action.payload;
    }
  }
});

export default building.reducer;

// Actions
export const { getListSuccess, setLevel } = building.actions;

export function getList() {
  return async () => {
    try {
      const response = await axios.post(`building/get_my`);

      if (response.data.code === 0) {
        dispatch(building.actions.getListSuccess(response.data.data));
      } else {
        dispatch(building.actions.getListSuccess([]));
      }
    } catch (error) {
      dispatch(building.actions.getListSuccess([]));
      dispatch(building.actions.hasError(error));
    }
  };
}
interface getBuildingExpendParams {
  buildId: string;
  buildType: string;
  toLevel: number;
}

export function getBuildingExpend({ buildId, buildType, toLevel }: getBuildingExpendParams) {
  return async () => {
    try {
      const response = await axios.post(`building/get`, { build_id: buildId, build_type: buildType, to_level: toLevel });

      if (response.data.code === 0) {
        dispatch(building.actions.getBuildingExpendSuccess(response.data.data));
      } else {
        dispatch(building.actions.getBuildingExpendSuccess(null));
      }
    } catch (error) {
      dispatch(building.actions.getBuildingExpendSuccess(null));
      dispatch(building.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export interface Building {
  build_id: string;
  build_type: string;
  icon: string;
  level: number;
  to_level: number;
  max_level: number;
  name: string;
}

export interface PreBuilding {
  build_name: string;
  build_type: string;
  food: number;
  from_level: number;
  ore: number;
  silver: number;
  time: number;
  to_level: number;
  wood: number;
  icon: string;
  item_list: ExpendItem[];
}

export interface Expend {
  total_wood: number;
  total_food: number;
  total_ore: number;
  total_silver: number;
  total_time: number;
  total_power: number;
  total_score: number;
  item_list: ExpendItem[];
  build: PreBuilding;
  pre_build: PreBuilding[];
}

export interface ExpendItem {
  icon: string;
  item_id: string;
  item_name: string;
  item_num?: number;
}

export interface BenefitItem {
  item_id: string;
  item_name: string;
  icon: string;
  item_percent: number;
}

export interface Benefit {
  food: number;
  food_percent: number;
  item_list: BenefitItem[];
  ore: number;
  ore_percent: number;
  silver: number;
  silver_percent: number;
  wood: number;
  wood_percent: number;
  speed_percent: number;
}
